import angular from 'angular';
import { Lang } from 'Roblox';

const recommendations = angular
  .module('recommendations', [
    'robloxApp',
    'thumbnails',
    'recommendationsAppTemplates',
    'glideCarousel'
  ])
  .config([
    'languageResourceProvider',
    languageResourceProvider => {
      if (Lang.RecommendationsResources) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.RecommendationsResources);
      }
    }
  ]);

export default recommendations;
